
















import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class InputFile extends Vue {
  public toImport: any = null;
  public uiReader: any = null;
  // @PropSync('accountToImport', { type: String }) private account!: any;
  public account: any = null;

  // public readAccount(address: string): string {
  //   if (address) {
  //     this.uiReader = JSON.parse(address);
  //     return `${this.uiReader.address.slice(0, 6)}...${this.uiReader.address.slice(-6)}
  //       ${this.uiReader.meta.name}`;
  //   }
  //   return '';
  // }

  @Watch('toImport')
  public createInput(file: any): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.account = reader.result;
    };
    reader.readAsText(file);
  }

}
